import React, { useContext, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { ShopContext } from '../context/shopcontext';
import validator from 'validator';
import Title from '../components/Title';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const { backendUrl } = useContext(ShopContext);

  const onSubmitHandler = async (e) => {
    e.preventDefault();

    if (!validator.isEmail(email)) {
      toast.error('Please enter a valid email address');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${backendUrl}/api/user/forgot-password`, {
        email: email.trim(),
      });
      toast.success(response.data.message || 'If the email exists, a reset link will be sent.');
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Something went wrong';
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={onSubmitHandler}
      className="flex flex-col items-center w-[90%] sm:max-w-96 m-auto mt-32 px-4  gap-4"
      style={{ color: '#4c0f2e', borderRadius: '10px', padding: '20px' }}
    >
      <Title text1={'FORGOT '} text2={'PASSWORD'} />

      <input
        type="email"
        placeholder="Enter your email"
        value={email}
        onChange={(e) => setEmail(e.target.value.trim())}
        required
        autoComplete="email"
        aria-label="Email Address"
        className="w-full px-3 py-2 border-2 border-[#b09287] focus:border-[#b09287] focus:outline-none text-[#4c0f2e]"
      />

      {/* Inline email format warning */}
      {email && !validator.isEmail(email) && (
        <p className="text-red-500 text-sm w-full text-left">Invalid email format</p>
      )}

      <button
        type="submit"
        disabled={loading || email.trim() === ''}
        className={`bg-gradient-to-r from-[#4c0f2e] to-[#2a081a] shadow-md rounded-md text-white px-8 py-2 mt-2 w-full text-center transition-all duration-200 ${
          loading || email.trim() === ''
            ? 'cursor-not-allowed opacity-70'
            : 'hover:shadow-lg cursor-pointer'
        }`}
      >
        {loading ? 'Sending...' : 'Send Reset Link'}
      </button>

      <p className="text-sm text-[#4c0f2e] mt-3">
        Remembered your password?{' '}
        <a href="/login" className="text-[#4c0f2e] underline hover:text-[#4c0f2e]">
          Login
        </a>
      </p>
    </form>
  );
};

export default ForgotPassword;
